import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/videos", label: "挠痒视频", end: false },
  { to: "/articles", label: "趣味文章", end: false },
  { to: "/community", label: "社区交流", end: false },
  { to: "/about", label: "关于我们", end: false },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [mobileKeyword, setMobileKeyword] = useState("");

  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    window.addEventListener("resize", close);
    return () => window.removeEventListener("resize", close);
  }, [menuOpen]);

  const submitSearch = (value: string, closeAfter = false) => {
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    if (closeAfter) {
      setMenuOpen(false);
      setMobileKeyword("");
    }
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-foreground-950 md:h-10 md:w-10">
            <i className="ri-footprint-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg text-foreground-950 md:text-xl">挠脚心网站</span>
            <span className="mt-1 hidden text-[10px] tracking-[0.22em] text-foreground-500 md:block">
              TICKLE &amp; SMILE
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-100 font-medium text-foreground-950"
                    : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden items-center md:flex">
          <form
            onSubmit={(event) => {
              event.preventDefault();
              submitSearch(keyword);
            }}
            className="flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-1.5 transition-colors focus-within:border-primary-400"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索视频、文章、帖子"
              aria-label="搜索站内内容"
              className="w-32 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none lg:w-48"
            />
            <button
              type="submit"
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-foreground-950 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 lg:hidden">
          <form
            onSubmit={(event) => {
              event.preventDefault();
              submitSearch(mobileKeyword, true);
            }}
            className="mb-3 flex items-center gap-2 rounded-lg border border-background-300/70 bg-background-100 px-3 py-2"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              value={mobileKeyword}
              onChange={(event) => setMobileKeyword(event.target.value)}
              placeholder="搜索视频、文章、帖子"
              aria-label="搜索站内内容"
              className="w-full bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none"
            />
            <button
              type="submit"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-foreground-950"
            >
              搜索
            </button>
          </form>
          <div className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-lg px-3 py-3 text-sm ${
                    isActive
                      ? "bg-primary-100 font-medium text-foreground-950"
                      : "text-foreground-700"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-base text-foreground-400"></i>
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}